import { render } from "./Rank.vue?vue&type=template&id=591ce842"
import script from "./Rank.vue?vue&type=script&lang=js"
export * from "./Rank.vue?vue&type=script&lang=js"
script.render = render

export default script